import camelize from 'camelize';

export const thumbnailFromBlock = block => {
  block = camelize(block);
  switch (block.blockType) {
    case 'image_grid': {
      if (block.items.length) {
        return block.items[0].media || null;
      }
      break;
    }
    case 'image_with_text':
      return block.media;
    case 'image_comparison':
      return block.image1;
    case 'media':
      return block.media;
    default:
      return null;
  }
};

export const thumbnailFromBlocks = blocks => {
  for (const block of blocks) {
    const mediaId = thumbnailFromBlock(block);
    if (mediaId) {
      return mediaId;
    }
  }
};
